import { FC, PropsWithChildren } from 'react';
import { Merge } from 'type-fest';

import styles from 'bloko/blocks/chips/chip.less';

import { ChipProps } from './RadioChip';

const Chip: FC<Merge<JSX.IntrinsicElements['input'], ChipProps> & PropsWithChildren> = (props) => {
    const { children, innerRef, labelProps, wrapperProps, source, ...inputProps } = props;

    return (
        <label className={styles['bloko-chips-chip']} {...wrapperProps} ref={innerRef} source={source}>
            <input {...inputProps} type="checkbox" className={styles['bloko-chips-chip__input']} />
            <span className={styles['bloko-chips-chip__content']} {...labelProps}>
                {children}
            </span>
        </label>
    );
};

export default Chip;
